import {
  KoModal,
  KoText,
  KoButton,
  KoLoader,
  KoTag,
  KoEmpty
} from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './releases.module.scss';

function DiffViewer({ open, onClose, diffData, loading, prTitle, prNumber, externalUrl, gitProvider }) {
  const openExternal = () => {
    if (externalUrl) window.open(externalUrl, '_blank');
  };

  const fileStatusColor = {
    added: 'success',
    deleted: 'error',
    modified: 'processing',
    renamed: 'warning'
  };

  return (
    <KoModal
      title={
        <div className={styles.diffModalTitle}>
          <KoIcon name='DiffOutlined' width={16} height={16} />
          <KoText text={`PR #${prNumber} — ${prTitle}`} className={styles.modalTitleText} />
          {externalUrl && (
            <KoButton
              type='link'
              size='small'
              icon={<KoIcon name='ExternalLinkOutlined' width={12} height={12} />}
              label={`View on ${gitProvider || 'Git'}`}
              onClick={openExternal}
              className={styles.externalBtn}
            />
          )}
        </div>
      }
      centered
      open={open}
      handleOk={onClose}
      onClose={onClose}
      width={'min(1100px, 95vw)'}
      className={styles.diffModal}
      footer={[
        <KoButton key='close' label='Close' onClick={onClose} />,
        externalUrl && (
          <KoButton
            key='external'
            icon={<KoIcon name='ExternalLinkOutlined' width={14} height={14} />}
            label={`Open full diff on ${gitProvider || 'Git'}`}
            onClick={openExternal}
          />
        )
      ].filter(Boolean)}
    >
      <div className={styles.diffContainer}>
        {loading && <KoLoader />}

        {!loading && !diffData?.files?.length && (
          <KoEmpty description='No diff data available' />
        )}

        {!loading && diffData?.files?.map((file, fi) => (
          <div key={fi} className={styles.fileBlock}>
            <div className={styles.fileHeader}>
              <div className={styles.fileHeaderLeft}>
                <KoIcon name='FileOutlined' width={13} height={13} />
                <KoText className={styles.filename} text={file.filename} />
                <KoTag color={fileStatusColor[file.status] || 'default'}>
                  {file.status}
                </KoTag>
              </div>
              <div className={styles.fileHeaderRight}>
                <span className={styles.diffAdditions}>+{file.additions}</span>
                <span className={styles.diffDeletions}>-{file.deletions}</span>
              </div>
            </div>

            {file.chunks?.map((chunk, ci) => (
              <div key={ci} className={styles.chunk}>
                <div className={styles.hunkHeader}>
                  <KoText className={styles.hunkHeaderText} text={chunk.header} />
                </div>
                <div className={styles.linesWrap}>
                  {chunk.lines?.map((line, li) => (
                    <div
                      key={li}
                      className={`${styles.diffLine} ${styles[`diffLine_${line.type}`]}`}
                    >
                      <span className={styles.lineNum}>
                        {line.type !== 'add' ? (line.oldLine ?? '') : ''}
                      </span>
                      <span className={styles.lineNum}>
                        {line.type !== 'remove' ? (line.newLine ?? '') : ''}
                      </span>
                      <span className={styles.lineSign}>
                        {line.type === 'add' ? '+' :
                          line.type === 'remove' ? '-' : ' '}
                      </span>
                      <code className={styles.lineContent}>
                        {line.content}
                      </code>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </KoModal>
  );
}

export default DiffViewer;
